import { designSystemTheme } from 'ia-react-core';
import { AppTheme } from '../interfaces/Theme';

const appTheme: AppTheme = {
  ...designSystemTheme,
  layout: {
    ...designSystemTheme.layout,
    maxContentWidth: 100000,
  },
  Modal: {
    ...designSystemTheme.Modal,
    background: '#fff',
    closeButtonBackground: 'transparent',
    closeButtonHoverBackground: 'transparent',
    closeButtonActiveBackground: 'transparent',
  },
};

export default appTheme;
